import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { setIsListNeeds } from "../../../redux/slices/SearchBarSlice";
import { useDispatch, useSelector } from "react-redux";
import { statusOfRequest } from "../../../components/Header/Data";
import { toast } from "react-toastify";

const ActivateNeedModal = ({ fetchData }) => {
  const dispatch = useDispatch();
  const { isListNeeds, selectedNeed } = useSelector((state) => state.searchBar);
  const { allNeeds, myNeeds } = useSelector((state) => state.myNeeds);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const userNeeds = allNeeds.filter(
    (need) => need.createdBy === selectedNeed?.createdBy
  );
  console.log(selectedNeed, "selectedNeed");
  const handleClose = async () => {
    const userId = { createdBy: user.UserID, Status: 4 };
    await statusOfRequest(userId, selectedNeed.Id);
    toast.success(`${selectedNeed.Title} Deactivated`);
    fetchData();
    dispatch(setIsListNeeds(false));
  };
  const onApprove = async () => {
    if (selectedNeed?.Email === "" || selectedNeed?.Email === null) {
      toast.error("Please Enter Email ID");
      return;
    }
    if (
      selectedNeed?.checkedValue === "mobile" &&
      selectedNeed?.dialExtension === ""
    ) {
      toast.error("Please add dial extension");
      return;
    }
    if (selectedNeed?.needRadius === null) {
      toast.error("Please Select Radius");
      return;
    }
    if (selectedNeed?.engagedCouple === 0 && !selectedNeed?.Gurudwara) {
      toast.error("Please add Gurudwara Name");
      return;
    }
    const userId = { createdBy: user.UserID, Status: 1 };
    await statusOfRequest(userId, selectedNeed.Id);
    toast.success(`${selectedNeed.Title} Activated`);
    fetchData();
    dispatch(setIsListNeeds(false));
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      padding: "8px",
      textAlign: "center",
      minWidth: 100,
      maxWidth: 200,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: "8px",
      textAlign: "center",
      minWidth: 100,
      maxWidth: 200,
      "&:hover": {
        backgroundColor: theme.palette.action.selected,
      },
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
    "& td, & th": {
      padding: "8px",
      lineHeight: 1.2,
      textAlign: "center",
    },
  }));

  return (
    <React.Fragment>
      <Dialog
        open={isListNeeds}
        onClose={() => dispatch(setIsListNeeds(false))}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ "& .MuiDialog-paper": { maxWidth: "1000px", margin: 1 } }}
      >
        <DialogTitle id="alert-dialog-title" sx={{ padding: "16px" }}>
          {`${selectedNeed?.FullName}'s Needs List`}
        </DialogTitle>
        <DialogContent sx={{ padding: 2 }}>
          {userNeeds && userNeeds.length > 0 && (
            <TableContainer component={Paper} sx={{ margin: 0, padding: 0 }}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Title</StyledTableCell>
                    <StyledTableCell align="right">Decription</StyledTableCell>
                    <StyledTableCell align="right">categoryId</StyledTableCell>
                    <StyledTableCell align="right">
                      Event / Normal Need
                    </StyledTableCell>
                    <StyledTableCell align="right">Status</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userNeeds.map((need) => (
                    <StyledTableRow key={need.Id}>
                      <StyledTableCell component="th" scope="row">
                        {need?.Title}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {need?.Description}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {need?.categoryName}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {need?.engagedCouple === 1 ? "Event" : "Normal Need"}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <div>
                          {need?.Status === 0 && (
                            <span className="badge badge-warning">Pending</span>
                          )}
                          {need?.Status === 1 && (
                            <span className="badge badge-success">Active</span>
                          )}
                          {need?.Status === 2 && (
                            <span className="badge badge-danger">Deleted</span>
                          )}
                          {need?.Status === 3 && (
                            <span className="badge badge-secondary">
                              Expired / Paused
                            </span>
                          )}
                        </div>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "8px", gap: "8px" }}>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={onApprove} autoFocus>
            Approve
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ActivateNeedModal;
